import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import Select from "@UI/New/Select";
import { directionAPI } from "@/api";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import useRoles from "@/hooks/useRoles";
import useLoad from "@/hooks/useLoad";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { useGetDirection } from "@/hooks/useGetDirection";

export const CourseSelection = () => {
    const { isSeminarian } = useRoles();
    const { state, setFieldInState } = useContext(ModalSettingContext);
   
    const direction = useGetDirection(
        isSeminarian,
        { anySeminarian: false }
    );

    const fieldsCourse = {
        loading: direction.loading,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: e => setFieldInState(
            {
                field: 'direction', 
                value: e, 
                resetFields: ['speaker_id', 'groups', 'seminariansСlasses', 'unavailableStudents', 'childrens', 'tariff']
            }
        ),
        options: direction.select,
        value: state.direction,
        placeholder: 'Выберите курс',
        notFoundContent: "Курсы не найдены" 
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsCourse} 
        />
    );
};